
// @ts-ignore
import {ColDef, ColumnState, GridApi, IDatasource,} from "ag-grid-community";
// @ts-ignore
import {AgGridVue} from "ag-grid-vue3";
import axios, {AxiosRequestConfig, AxiosTransformer} from "axios";
import {debounce} from "lodash";
import {defineComponent, onUnmounted, PropType, ref, watch} from "vue";
import route from "ziggy-js";


export default defineComponent({
  components: {
    AgGridVue,
  },
  props: {
    useServerData: {
      type: Boolean,
      default: () => true,
    },
    filter: {
      type: Object,
      required: false,
    },
    routeName: {
      type: String,
      required: false,
    },
    responseTransformer: {
      type: Function as PropType<AxiosTransformer>,
      required: false,
    },
    columnDefs: {
      type: Array as PropType<ColDef[]>,
      required: true,
    },
    mobileColumnDefs: {
      type: Array as PropType<ColDef[]>,
      required: false,
    },
    defaultSortModel: {
      type: Array as PropType<ColumnState[]>,
      required: false,
    },
    count: {
      type: Number,
      required: false,
    },
    defaultColDef: {
      type: Object as PropType<ColDef>,
      required: false,
    },
    getRowHeight: {
      type: Function,
    },

    rowHeight: {
      type: Number,
      required: false,
      default: () => 50
    },
    mobileBreakpoint: {
      type: Number,
      required: false,
      default: () => 768,
    },
  },
  name: "App",
  emits: ['setGridApi'],
  setup(props, {emit}) {
    const currentRouteName = route().current() ?? "";
    const count = ref(props.count);
    const defaultColDef = ref(props.defaultColDef);
    if (!count.value) {
      count.value = 50;
    }
    if (!props.defaultColDef) {
      defaultColDef.value = {};
    }
    const gridOptions: any = {
      rowModelType: props.useServerData ? "infinite" : "clientSide",
      getRowHeight: props.getRowHeight ?? null,
      rowBuffer: 20,
      datasource: {
        getRows: (params) => {
          if (!props.routeName) {
            params.failCallback();
          }

          const options = {
            params: {
              ...props.filter,
              sortBy: params.sortModel[0]?.colId,
              sortDirection: params.sortModel[0]?.sort,
              startRow: params.startRow,
              endRow: params.endRow,
            },
            timeout: 20000,
          } as AxiosRequestConfig;

          if (props.responseTransformer) {
            options.transformResponse = [props.responseTransformer];
          }
          const routeName = props.routeName ?? "";

          axios
            .get(route(routeName), options)
            .then((response) => {
              params.successCallback(response.data.data, response.data.total);
            })
            .catch((reason) => {
              console.error("Fail!");
              console.error(reason);
              params.failCallback();
            });
        },
      } as IDatasource,
      isExternalFilterPresent: () => {
        if (props.filter) {
          return true;
        }

        return false;
      },
    };

    let gridApi: GridApi | null = null;

    const onGridReady = (params: { api: GridApi; }) => {
      gridApi = params.api;
      emit('setGridApi', params.api)
      window.addEventListener("resize", resizeGrid);

      if (props.defaultSortModel) {
        params.api.applyColumnState({
          state: props.defaultSortModel,
        });
      }
    };


    onUnmounted(() => {
      removeEventListener("resize", resizeGrid);
    });

    const resizeGrid = debounce(() => {
      requestAnimationFrame(() => {
        if (
          props.mobileColumnDefs &&
          window.innerWidth < props.mobileBreakpoint
        ) {
          gridApi?.setGridOption("columnDefs", props.mobileColumnDefs);
        } else if (props.mobileColumnDefs) {
          gridApi?.setGridOption("columnDefs", props.columnDefs);
        }

        gridApi?.sizeColumnsToFit();
        gridApi?.resetRowHeights();
      });
    }, 20);

    watch(
      () => props.filter,
      () => {
        gridApi?.onFilterChanged();
      },
      {
        deep: true,
      }
    );

    return {
      gridOptions,
      onGridReady,
      resizeGrid,
      defaultColDef,
    };
  },
});
